import { PageData } from "../../api/object/PageResult";
import React from "react";
import { Icon, Link } from "@fluentui/react";

interface PagerProps {
  page: PageData;
  updatePageNumber: (pageNumber: number) => void;
  alwaysVisible?: boolean;
}

export const Pager: React.FunctionComponent<PagerProps> = (props) => {
  const { page, updatePageNumber, alwaysVisible } = props;
  return (
    (alwaysVisible || page.totalPages > 1) && (
      <div
        style={{
          position: "absolute",
          bottom: "65px",
          width: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            padding: "0 40px",
          }}
        >
          <Link onClick={() => updatePageNumber(0)} disabled={page.number <= 0}>
            <Icon aria-label="Previous" iconName="DoubleChevronLeft" />
          </Link>
          <Link onClick={() => updatePageNumber(page.number - 1)} disabled={page.number <= 0}>
            <Icon aria-label="Previous" iconName="ChevronLeft" />
          </Link>
          <div>
            {" "}
            {page.number + 1} / {page.totalPages}
          </div>
          <Link onClick={() => updatePageNumber(page.number + 1)} disabled={page.number >= (page.totalPages ?? 0) - 1}>
            <Icon aria-label="Next" iconName="ChevronRight" />
          </Link>
          <Link
            onClick={() => updatePageNumber(page.totalPages - 1)}
            disabled={page.number >= (page.totalPages ?? 0) - 1}
          >
            <Icon aria-label="Next" iconName="DoubleChevronRight" />
          </Link>
        </div>
      </div>
    )
  );
};
